import styled from '@emotion/styled';

export const Message = styled.div`
  background: #FD2C14;
  color: #fff;
  font-size: 1rem;
  font-weight: 800;
  padding: 1rem;
`;
